import { render, staticRenderFns } from "./OptionTemplateDialog.vue?vue&type=template&id=27183ad0&scoped=true"
import script from "./OptionTemplateDialog.vue?vue&type=script&lang=ts"
export * from "./OptionTemplateDialog.vue?vue&type=script&lang=ts"
import style0 from "./OptionTemplateDialog.vue?vue&type=style&index=0&id=27183ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27183ad0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VIcon})
